import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap"; // Import React-Bootstrap
import Header from "../components/header/Header";
import ProgressBar from "../components/progressBar/ProgressBar";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../redux/actions/CartActions";
import { FaBuilding, FaUser, FaUserFriends } from "react-icons/fa";
import { isAssociation } from "../utils/creationFlow";

const managerTypes = [
  {
    label: "Moi-même",
    value: "myself",
    icon: <FaUser size={50} style={{ margin: "15px auto" }} color="#051259" />,
  },
  {
    label: "Un autre particulier",
    value: "individual",
    icon: (
      <FaUserFriends
        size={50}
        style={{ margin: "15px auto" }}
        color="#051259"
      />
    ),
  },
  // {
  //   label: "Une entreprise",
  //   value: "company",
  //   icon: (
  //     <FaBuilding size={50} style={{ margin: "15px auto" }} color="#051259" />
  //   ),
  // },
];

function ManagerType() {
  const navigate = useNavigate();
  const currentStep = "Propriétaire";
  const steps = [
    "Propriétaire",
    "Entreprise",
    "Services",
    "Paiement",
    "Finalisation",
  ];
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart);

  const association =
    cart.from === "creation" && isAssociation(cart.businessType);

  const handleManagerTypeSelect = async (managerType) => {
    await dispatch(
      addToCart({
        managerType: managerType,
      }),
    );
    // An association goes straight to its name once the president is known
    if (managerType === "myself" && association) {
      navigate("/business-name");
    } else if (managerType === "myself") {
      navigate("/owner-marital-status");
    } else if (managerType === "individual") {
      navigate("/manager-name");
    } else if (managerType === "company") {
      navigate("/manager-business-name");
    }
  };

  return (
    <div
      style={{
        backgroundColor: "#fff",
        paddingBottom: "40px",
        position: "relative",
      }}
    >
      <Header />

      <ProgressBar steps={steps} currentStep={currentStep} />

      <Container className="mt-4 text-center">
        {association ? (
          <h4 className="text-2xl font-semibold">
            Qui sera le <span style={{ color: "#FF5500" }}>président</span> de
            votre association ?
          </h4>
        ) : (
          <h4 className="text-2xl font-semibold">
            Qui sera le{" "}
            <span style={{ color: "#FF5500" }}>gérant principal</span> de votre{" "}
            {cart?.businessType} ?
          </h4>
        )}
      </Container>

      <Container className="mt-4 d-flex justify-content-center">
        <Row className="w-100" style={{ maxWidth: "900px" }}>
          {managerTypes.map((managerType, index) => (
            <Col
              xs={12}
              md={6}
              lg={6}
              className="mb-4 d-flex justify-content-center"
              key={index}
            >
              <div
                className="ownertype-box"
                onClick={() => handleManagerTypeSelect(managerType.value)}
                style={{
                  width: "100%",
                  minHeight: "140px",
                  border:
                    cart.managerType === managerType.value
                      ? "2px solid #FF5500"
                      : "2px solid #ddd",
                  borderRadius: "8px",
                  padding: "15px",
                  cursor: "pointer",
                  transition: "border-color 0.3s",
                  textAlign: "center",
                  color: "#000",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.borderColor = "#FF5500")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.borderColor =
                    cart.managerType === managerType.value ? "#FF5500" : "#ddd")
                }
              >
                <div>{managerType.icon}</div>
                <span style={{ fontSize: "1rem" }}>
                  {association && managerType.value === "individual"
                    ? "Une autre personne"
                    : managerType.label}
                </span>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}

export default ManagerType;
